import { FormProvider } from 'react-hook-form';

import { Button, ButtonSize, ButtonType } from '@xemplo/button';
import { Modal, ModalDialogSlot } from '@xemplo/modal-dialog';

import * as S from './payrun-prepare.styles';
import { PayrunPrepareProps } from './payrun-prepare.types';
import { ModalBody } from './payrun-prepare-modal-body';
import { TestIds } from './payrun-prepare-test.helper';
import { usePayunPrepare } from './use-payrun-prepare';

export const PayrunPrepare = (props: Readonly<PayrunPrepareProps>) => {
  const { className } = props;
  const { dialogProps, isOpen, openModalDialog, closeDialog, handleSubmit, methods } =
    usePayunPrepare(props);

  return (
    <>
      <Modal.Dialog {...dialogProps}>
        {isOpen ? (
          <Modal>
            <Modal.Slot
              name={ModalDialogSlot.CloseButton}
              render={
                <Modal.CloseButton
                  onClick={closeDialog}
                  id="payrun-prepare-modal-close-button"
                  ariaLabel="close button"
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Header}
              render={<Modal.Header title={'Confirm payrun preparation?'} />}
            />
            <Modal.Slot
              name={ModalDialogSlot.Body}
              render={
                <Modal.Body>
                  <FormProvider {...methods}>
                    <ModalBody />
                  </FormProvider>
                </Modal.Body>
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Footer}
              render={
                <Modal.Footer
                  btnPrimary={{
                    onClickAsync: handleSubmit,
                    label: 'Yes',
                    ariaLabel: 'Button to submit prepare payrun',
                    type: ButtonType.Primary,
                  }}
                  btnTertiary={{
                    onClick: closeDialog,
                    label: 'Cancel',
                    ariaLabel: 'Button to cancel prepare payrun',
                    type: ButtonType.Tertiary,
                  }}
                />
              }
            />
          </Modal>
        ) : null}
      </Modal.Dialog>
      <S.ButtonDiv className={className}>
        <Button
          ariaLabel={'prepare-payrun'}
          type={ButtonType.Primary}
          size={ButtonSize.Small}
          onClick={() => openModalDialog()}
          testId={TestIds.PreparePayrunCompleteButton}
        >
          Complete
        </Button>
      </S.ButtonDiv>
    </>
  );
};

export default PayrunPrepare;
